import { lazy } from 'react';

const ReceivedTransferCollectivePlanConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/plan/consult/received-transfer-info',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedTransferCollectivePlanConfig;


